import { render, staticRenderFns } from "./DesignIconPopper.vue?vue&type=template&id=77bcb4c2&scoped=true&"
import script from "./DesignIconPopper.vue?vue&type=script&lang=js&"
export * from "./DesignIconPopper.vue?vue&type=script&lang=js&"
import style0 from "./DesignIconPopper.vue?vue&type=style&index=0&id=77bcb4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcb4c2",
  null
  
)

export default component.exports